"use client";

import type { FC, PropsWithChildren } from "react";

import classNames from "classnames";

import { Loader } from "@jti/core-components/components/Loader";
import { useSelector } from "@jti/store/reduxHooks";
import { type RootStoreState } from "@jti/store/types";

import styles from "./GeneralLayout.module.scss";

const GeneralLayout: FC<PropsWithChildren<{ isInEditor?: boolean }>> = ({ children, isInEditor }) => {
  const isLoaded = useSelector((state: RootStoreState) => state.loyaltyCore.isLoaded);

  return (
    <>
      {!isLoaded && !isInEditor && (
        <div className={classNames(styles.loaderOverlay, "light-theme")}>
          <Loader data-testid="loader" />
        </div>
      )}
      {children}
    </>
  );
};

export default GeneralLayout;
